// extracted by mini-css-extract-plugin
export const featured = "indexMainStyles-module--featured--3dttv";
export const gatsbyImageWrapperConstrained = "indexMainStyles-module--gatsby-image-wrapper-constrained--xjJnT";
export const indexMainTitle = "indexMainStyles-module--indexMainTitle--1g-9M";
export const title = "indexMainStyles-module--title--1y_S5";
export const mainTitle = "indexMainStyles-module--mainTitle--3UYYd";
export const light = "indexMainStyles-module--light--uIDZI";
export const dark = "indexMainStyles-module--dark--3-3K9";
export const indexRightSmall = "indexMainStyles-module--indexRightSmall--2aKuX";
export const indexTextSmall = "indexMainStyles-module--indexTextSmall--3OAXa";
export const darkPostsRow = "indexMainStyles-module--darkPostsRow--24drB";
export const indexRightSmallText = "indexMainStyles-module--indexRightSmallText--1QRtZ";
export const category_badge = "indexMainStyles-module--category_badge--37DKO";
export const indexBackgroundContainer = "indexMainStyles-module--indexBackgroundContainer--224yX";
export const sectionHeadingText = "indexMainStyles-module--sectionHeadingText--1oNL3";
export const mainIndexContainer = "indexMainStyles-module--mainIndexContainer--3E1bB";
export const indexPost = "indexMainStyles-module--indexPost--1KZ-P";
export const top = "indexMainStyles-module--top--1j7Mh";
export const bottom = "indexMainStyles-module--bottom--2Fr2G";
export const gatsbyImageWrapper = "indexMainStyles-module--gatsby-image-wrapper--DfPsB";
export const right = "indexMainStyles-module--right--2oIYx";
export const category = "indexMainStyles-module--category--2R8zD";
export const categorySection = "indexMainStyles-module--categorySection--1aF-n";
export const left = "indexMainStyles-module--left--2r8QP";
export const showMobileOnly = "indexMainStyles-module--showMobileOnly--2IaWH";
export const darkCover = "indexMainStyles-module--darkCover--1g2XE";